var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useEffect } from 'react';
import { Card } from './gameScreen/GameScreen';
import { Timer } from './Timer/Timer';
import { prepare, shuffle } from '../common/functions';
import { Preloader } from './preload/preloader';
import './exit_link.css';
export function Game(props) {
    var _this = this;
    var _a = useState(false), end = _a[0], setEnd = _a[1];
    var _b = useState(false), isLoaded = _b[0], setIsLoaded = _b[1];
    var _c = useState([]), items = _c[0], setItems = _c[1];
    var _d = useState(false), noWords = _d[0], setnoWords = _d[1];
    function updateEnd() {
        setEnd(true);
    }
    function playAgain() {
        setEnd(false);
        filterItems();
    }
    useEffect(function () {
        var resp = function () { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, prepare(props.page, props.group, props.fromPage)];
                    case 1:
                        response = (_a.sent());
                        setIsLoaded(true);
                        setItems(response);
                        if (response.length === 0) {
                            setEnd(true);
                            setnoWords(true);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        resp();
    }, [props.fromPage, props.group, props.page]);
    function filterItems() {
        if (items.length === 0)
            setEnd(true);
        if (!props.fromPage)
            return shuffle(items);
        else {
            var filtered = items.filter(function (element) { var _a, _b; return !((_b = (_a = element.properties) === null || _a === void 0 ? void 0 : _a.optional) === null || _b === void 0 ? void 0 : _b.isKnown); });
            if (filtered.length > 0)
                return shuffle(filtered);
            else {
                setnoWords(true);
                setEnd(true);
                return items;
            }
        }
    }
    if (!isLoaded) {
        return React.createElement(Preloader, null);
    }
    else {
        return (React.createElement("div", { className: "gameboard" },
            React.createElement(Timer, { seconds: "60", endFunc: updateEnd, reset: end }),
            React.createElement(Card, { items: items, end: end, func: playAgain, reset: end, fromPage: props.fromPage || false, endfunc: updateEnd, noWords: noWords })));
    }
}
